import { render, staticRenderFns } from "./points-detail.vue?vue&type=template&id=da24b6cc&"
import script from "./points-detail.vue?vue&type=script&lang=js&"
export * from "./points-detail.vue?vue&type=script&lang=js&"
import style0 from "./points-detail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports